namespace $.$$ {
	export class $shm_hitalama_docs extends $.$shm_hitalama_docs {

		@ $mol_mem
		text() {
			return this.$.$mol_fetch.text( 'shm/ba/readme.md' )
		}

	}
}
